import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { RAFUnitOfWork, AppInformationService, AuthenticationService } from 'src/app/core/core.module';
import { DxDataGridComponent, DxPivotGridComponent } from 'devextreme-angular';
import { EntityQuery } from 'breeze-client';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router, ActivatedRoute } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { SharedModule } from 'src/app/shared/shared.module';
import { TimeEditDialogComponent } from '../time-edit-dialog/time-edit-dialog.component';

@Component({
    selector: 'app-time-payroll',
    templateUrl: './time-payroll.component.html',
    styleUrls: ['./time-payroll.component.scss'],
    standalone: false
})
export class TimePayrollComponent implements OnInit {
    filter: any;
    currentDate: Date;
    pivotDataSource: any;
    items: any;
    itemCount = 0;
    options = ['All', 'Unapproved'];

    entites: any;
    employees: any;
    showingPreviousWeek = false;

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('pivotGrid') pivotGrid: DxPivotGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        private router: Router,
        private auth: AuthenticationService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        private appInfo: AppInformationService
    ) {}

    async ngOnInit() {
        this.filter = {};
        this.filter.type = 'All';
        this.currentDate = new Date();
        this.switchWeeks(true);
        await this.getData();
    }

    switchWeeks(onInit?: boolean) {
        if (!this.showingPreviousWeek && !onInit) {
            this.filter.startDate = moment(this.filter.startDate).add(-7, 'days').startOf('day').toDate();
            this.filter.endDate = moment(this.filter.endDate).add(-7, 'days').startOf('day').toDate();
            this.showingPreviousWeek = true;
        } else {
            this.filter.startDate = moment(this.currentDate).isoWeekday(1).startOf('day').toDate();
            this.filter.endDate = moment(this.currentDate).isoWeekday(6).add(1, 'days').startOf('day').toDate();
            this.showingPreviousWeek = false;
        }
        this.getData();
    }

    async search() {
        await this.getData();
    }
    clear() {
        this.items = null;
        this.itemCount = 0;
        this.filter = {};
    }

    selectionChange(e) {
        console.log('value change');
    }

    onCellPrepared(e) {
        // if (this.filter.type !== 'All') {
        if (e.area === 'data' && e.cell.columnType === 'D' && e.cell.rowType === 'D') {
            const pivotGridDataSource = this.pivotGrid.instance.getDataSource();
            const drillDownDataSource = pivotGridDataSource.createDrillDownDataSource(e.cell);
            drillDownDataSource.paginate(false);
            drillDownDataSource.load().then((data) => {
                if (data.length > 0 && data[0].edited) {
                    e.cellElement.style.border = '3px solid yellow';
                    e.cellElement.style.backgroundColor = 'yellow';
                }
                if (data.length > 0 && data[0].approved) {
                    if (data[0].total > 0  && data[0].detailed) e.cellElement.style.backgroundColor = 'green';
                    else e.cellElement.style.backgroundColor = 'orange';
                }
            });
        }

        if (this.filter.type !== 'All' && e.area === 'data' && e.cell.columnType === 'D' && e.cell.rowType === 'D' && !!e.cell.value && e.cell.value > 20) {
            e.cellElement.style.backgroundColor = 'red';
        }
        // }
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const start = moment(this.filter.startDate).startOf('day').toDate();
        const end = moment(this.filter.endDate).startOf('day').toDate();

        this.items = await this.uow.getTimeReview(start, end, this.filter.type === 'Unapproved');
        this.itemCount = this.items.length;
        // console.log(this.items);
        // console.log(this.itemCount);

        this.pivotDataSource = {
            fields: [
                {
                    dataField: 'employee',
                    area: 'row',
                },
                {
                    dataField: 'type',
                    area: 'row',
                },
                {
                    dataField: 'job',
                    area: 'row',
                },
                {
                    dataField: 'total',
                    caption: `Hours (sum)`,
                    isMeasure: true,
                    area: 'data',
                    dataType: 'number',
                    format: {
                        type: '#0.00',
                    },
                    edited: true,
                },
                {
                    dataField: 'date',
                    caption: 'Date',
                    area: 'column',
                    dataType: 'date',
                    groupInterval: 'date',
                    format: {
                        type: 'shortDate',
                    },
                },
            ],
            store: this.items,
            retrieveFields: false,
        };
        this.appInfo.pleaseWaitHide();
    }

    contextMenuPreparing(e) {
        const dataSource = e.component.getDataSource();
        const sourceField = e.field;

        if (sourceField) {
            if (!sourceField.groupName || sourceField.groupIndex === 0) {
                e.items.push({
                    text: 'Hide field',
                    onItemClick: function () {
                        let fieldIndex;
                        if (sourceField.groupName) {
                            fieldIndex = dataSource.getAreaFields(sourceField.area, true)[sourceField.areaIndex].index;
                        } else {
                            fieldIndex = sourceField.index;
                        }

                        dataSource.field(fieldIndex, {
                            area: null,
                        });
                        dataSource.load();
                    },
                });
            }

            if (sourceField.dataType === 'number') {
                const setSummaryType = function (args) {
                        dataSource.field(sourceField.index, {
                            summaryType: args.itemData.value,
                        });
                        if (sourceField.caption.includes('Hours')) sourceField.caption = `Hours (${sourceField.summaryType.toLowerCase()})`;
                        dataSource.load();
                    },
                    menuItems = [];

                e.items.push({ text: 'Summary Type', items: menuItems });

                for (const summaryType of ['Sum', 'Avg', 'Min', 'Max', 'Count']) {
                    const summaryTypeValue = summaryType.toLowerCase();

                    menuItems.push({
                        text: summaryType,
                        value: summaryType.toLowerCase(),
                        onItemClick: setSummaryType,
                        selected: e.field.summaryType === summaryTypeValue,
                    });
                }
            }
        }
    }

    onCellClick(e) {
        // console.log('e', e);
        const filter: any = {};

        if (e.area === 'data') {
            e.rowFields.forEach((field) => {
                if (!e.cell.rowPath[field.areaIndex]) return;
                filter[field.dataField] = e.cell.rowPath[field.areaIndex];
            });
            e.columnFields.forEach((field) => {
                if (!e.cell.columnPath[field.areaIndex]) return;
                filter[field.dataField] = e.cell.columnPath[field.areaIndex];
            });

            // console.log('filter', filter);
            if (e.cell.columnType !== 'GT' && e.cell.rowType !== 'GT' && !!filter.employee && !!filter.date) this.editTime(filter);
        }

        if (e.cell.columnType === 'GT' || e.cell.rowType === 'GT') {
            if (!!filter.employee) this.approveAll(filter.employee);
        }
    }

    async approveAll(employeeInfo?: any) {
        let employeeInfos = [];
        employeeInfos = employeeInfo.split(' ');
        const result = await confirm(`Do you want to approve all time for ${employeeInfos[0]} ${employeeInfos[1]}?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        const employeeId = employeeInfos[employeeInfos.length - 1];
        this.appInfo.pleaseWaitShow();
        const items = (await this.uow.getTimeEntriesByEmployeeId(employeeId, this.filter.startDate, this.filter.endDate)) as any;
        items.forEach((x) => {
            x.approved = new Date();
        });
        await this.uow.commit();
        await this.getData();

        this.appInfo.pleaseWaitHide();
    }

    async editTime(filter: any) {
        const modalRef = this.modalService.show(TimeEditDialogComponent, {
            class: 'modal-mdw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                filter,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success || result.refreshData) {
                await this.getData();
            }
            modalRef.hide();
        });
    }
}
